import React from "react";
import home1 from "../image/home1.png";
import Textile from "../image/Textile.png";
import Export from "../image/Export.png";
import Capital from "../image/capital.png";
import customer from "../image/customer.png";
import Chemical from "../image/chemical.png";
// import Bac from "../image/Bac.png";
import non from "../image/non.png";
import parma from "../image/parma.png";
import real from "../image/real.png";
import tra from "../image/tra.png";
import imm from "../image/imm.png";
import Bac from "../image/Bac.png";
import sanjay from "../image/sanjay.jpeg";
import Bipin from "../image/Bipin.jpg";
import kaushik from "../image/kaushik.jpg";
import { useNavigate } from "react-router-dom";

const Home = () => {
  const industries = [
    { name: "Textile", image: Textile },
    { name: "Export", image: Export },
    { name: "Capital goods & Engineering", image: Capital },
    { name: "Chemical", image: Chemical },
    { name: "Banking and finance", image: Bac },
    { name: "Non-profit organisation", image: non },
    { name: "Pharmaceuticals", image: parma },
    { name: "Real Estate", image: real },
    { name: "Transportation", image: tra },
    { name: "Immigration", image: imm },

    // Add other industries here
  ];

  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/ContactUs");
  };

  const handleAppointmentClick = () => {
    window.open(
      "http://topmate.io/sanjay_nathani/?utm_source=topmate&utm_medium=popup&utm_campaign=Page_Ready",
      "_blank"
    );
  };
  return (
    <>
      <div className="bg-gray-100">
        {/* Hero Section */}
        <section
          className="bg-cover bg-center h-[500px] flex items-center justify-center"
          style={{ backgroundImage: `url(${home1})` }}
        >
          <div className="text-center text-bg-blue-800">
            <h1 className="text-4xl font-bold mb-4">
              WHILE YOU HANDLE YOUR BUSINESS
            </h1>
            <p className="text-lg mb-6">LET US HANDLE THE NUMBERS</p>
            <button className="bg-[#005A8C] text-white px-6 py-2 rounded hover:bg-white-600">
              Learn More
            </button>
          </div>
        </section>

        {/* Stats Section */}
        {/* <section className="bg-white py-8 shadow-md">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-6 text-center">
          <div>
            <h2 className="text-2xl font-bold text-blue-800">1000+</h2>
            <p className="text-gray-600">Total Clients</p>
          </div>
          <div>
            <h2 className="text-2xl font-bold text-blue-800">10+</h2>
            <p className="text-gray-600">Team Members</p>
          </div>
          <div>
            <h2 className="text-2xl font-bold text-blue-800">10000+</h2>
            <p className="text-gray-600">Work Done</p>
          </div>
          <div>
            <h2 className="text-2xl font-bold text-blue-800">13+</h2>
            <p className="text-gray-600">Experience</p>
          </div>
        </div>
      </section> */}

        <section className="bg-white py-8 shadow-md relative">
          <div className="max-w-7xl mx-auto px-4 md:px-8">
            <div className="grid grid-cols-1 md:grid-cols-4 gap-6 text-center border border-blue-300 rounded-lg p-6 bg-white relative">
              <div className="border-r border-blue-300 last:border-r-0">
                <h2 className="text-2xl font-bold text-orange-600">1000+</h2>
                <p className="text-blue-800 font-semibold">Total Clients</p>
              </div>
              <div className="border-r border-blue-300 last:border-r-0">
                <h2 className="text-2xl font-bold text-orange-600">10+</h2>
                <p className="text-blue-800 font-semibold">Team Members</p>
              </div>
              <div className="border-r border-blue-300 last:border-r-0">
                <h2 className="text-2xl font-bold text-orange-600">10000+</h2>
                <p className="text-blue-800 font-semibold">Work Done</p>
              </div>
              <div>
                <h2 className="text-2xl font-bold text-orange-600">13+</h2>
                <p className="text-blue-800 font-semibold">Experience</p>
              </div>

              {/* WhatsApp Button */}
              <a
                href="https://wa.me/your-number-here"
                target="_blank"
                rel="noopener noreferrer"
                className="fixed bottom-4 right-4 bg-green-500 text-white rounded-full px-4 py-2 shadow-lg flex items-center hover:bg-green-600 transition duration-300"
              >
                <svg
                  width="30"
                  height="30"
                  viewBox="0 0 30 30"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M14.7911 29.3525H14.7852C12.3967 29.3517 10.0498 28.7524 7.96534 27.6155L0.399994 29.6L2.42461 22.2048C1.17573 20.0405 0.518573 17.5855 0.519644 15.0702C0.522774 7.20169 6.92481 0.799999 14.7909 0.799999C18.6086 0.801647 22.1918 2.28786 24.8862 4.98541C27.5806 7.68282 29.0636 11.2683 29.0621 15.0815C29.059 22.9483 22.6595 29.3493 14.7911 29.3525ZM8.31586 25.0319L8.749 25.289C10.5702 26.3697 12.6578 26.9415 14.7863 26.9423H14.7911C21.3288 26.9423 26.6499 21.6211 26.6525 15.0807C26.6538 11.9112 25.4212 8.93108 23.1817 6.68899C20.9422 4.44689 17.964 3.21153 14.7957 3.21043C8.25292 3.21043 2.93177 8.53111 2.92917 15.0711C2.92825 17.3124 3.55536 19.4951 4.74273 21.3836L5.02476 21.8324L3.82648 26.2095L8.31586 25.0319ZM21.4924 18.1541C21.7411 18.2743 21.9091 18.3554 21.9808 18.4751C22.0699 18.6238 22.0699 19.3378 21.7729 20.1709C21.4756 21.0038 20.051 21.764 19.3659 21.8663C18.7516 21.9582 17.9741 21.9965 17.1199 21.725C16.602 21.5607 15.9379 21.3413 15.0871 20.9739C11.7442 19.5304 9.48502 16.2904 9.05805 15.678C9.02814 15.6351 9.00722 15.6051 8.99555 15.5895L8.99267 15.5857C8.80396 15.3339 7.53951 13.6468 7.53951 11.9008C7.53951 10.2582 8.34635 9.3973 8.71774 9.00101C8.74318 8.97386 8.76658 8.94889 8.78754 8.926C9.11439 8.569 9.50073 8.47975 9.73844 8.47975C9.97613 8.47975 10.2141 8.48195 10.4219 8.49238C10.4475 8.49367 10.4742 8.49351 10.5017 8.49335C10.7095 8.49214 10.9686 8.49062 11.2242 9.1045C11.3225 9.34076 11.4664 9.69102 11.6181 10.0604C11.9249 10.8074 12.264 11.6328 12.3236 11.7522C12.4128 11.9307 12.4722 12.1389 12.3533 12.377C12.3355 12.4126 12.319 12.4463 12.3032 12.4785C12.2139 12.6608 12.1483 12.7949 11.9967 12.9718C11.9372 13.0413 11.8756 13.1163 11.814 13.1913C11.6913 13.3407 11.5687 13.4901 11.4619 13.5965C11.2833 13.7743 11.0975 13.9673 11.3055 14.3243C11.5135 14.6813 12.2292 15.8489 13.2892 16.7945C14.4288 17.8109 15.4192 18.2405 15.9212 18.4582C16.0192 18.5008 16.0986 18.5352 16.1569 18.5644C16.5133 18.7429 16.7213 18.713 16.9294 18.4751C17.1374 18.2371 17.8208 17.4339 18.0584 17.0769C18.2961 16.7201 18.5339 16.7795 18.8607 16.8985C19.1877 17.0176 20.9408 17.8801 21.2974 18.0586C21.367 18.0935 21.4321 18.1249 21.4924 18.1541Z"
                    fill="#FDFDFD"
                  />
                </svg>

                <span className="font-medium ">Connect Now</span>
              </a>
            </div>
          </div>
        </section>

        {/* About Us Section */}
        <section className="bg-[#005A8C] text-white py-12">
          <div className="max-w-7xl mx-auto text-center">
            <h2 className="text-xl font-bold mb-4">About Us</h2>
            <p className="px-4 md:px-16">
              Sanjay K Nathani & Co. is professionally managed Chartered
              Accountancy firm providing one-stop solutions for Statutory Audit,
              Tax Audit, GST Audit, Direct Tax Compliance, Indirect Tax
              Compliance, Accounting Services, Business management consultancy,
              Various registration services Etc.We were established in 2012, we
              are a dedicated team of chartered accountants committed to
              providing comprehensive financial solutions. With over a decade of
              experience, we have built a reputation for delivering accurate,
              reliable, and insightful services to a diverse range of clients.
            </p>
          </div>
        </section>

        {/* Industries We Serve */}
        <section className="py-12">
          <div className="max-w-7xl mx-auto text-center">
            <h3 className="text-3xl font-bold mb-8">
              Industries <span className="text-orange-500">We Serve</span>
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
              {industries.map((industry) => (
                <div
                  key={industry.name}
                  className="bg-gray-200 rounded-lg p-4 shadow-md font-semibold"
                >
                  {/* Image rendering with error handling */}
                  <img
                    src={industry.image}
                    alt={industry.name}
                    onError={(e) => (e.target.src = Chemical)} // Fallback if image fails to load
                    className="rounded-md mb-4 w-full h-[150px] object-cover"
                  />
                  <p>{industry.name}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Our Team Section */}
        <section className="py-12 bg-gray-100">
          <div className="max-w-6xl mx-auto text-center">
            <h3 className="text-3xl font-bold mb-8">
              Our <span className="text-orange-500">Team</span>
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-justify">
              {[
                {
                  name: "Sanjay Nathani",
                  description:
                    "He is a Fellow member of the Institute of Chartered Accountants of India with a strong academic foundation, holding degrees in Law (LLB) and Commerce (B Com). He established this firm in 2012, bringing years of diverse experience to the table. His expertise spans a wide range of services, including Business Advisory, Tax Advisory, Risk Advisory, and both Direct and Indirect Taxation.His professionalism and expertise in serving clients to their satisfaction have always been an inspiration for all in the firm. His extensive knowledge and hard work are the pillars of this firm.",
                  img: sanjay,
                  der: "(FCA, LLB, DISA,BCom)",
                },
                {
                  name: "Kaushik Khunt",
                  description:
                    "He is a professional with a strong academic foundation, holding degrees of LLB and B Com. With over six years of experience in Accounting and Indirect Taxation, he possesses a deep understanding of the financial landscape. He is committed to providing client-focused, results-oriented service, offering strategic advice and dedicated support to ensure your financial success. He believes in building long-term relationships based on trust, transparency, and clear and concise communication, while adhering to the highest ethical and professional standards.",
                  img: kaushik,
                  der: "(LLB, Bcom)",
                },
                {
                  name: "Bipin Kathiriya",
                  description:
                    "He brings over 13 years of invaluable experience in accounting and indirect taxation. His extensive background spans various industries, providing him with a broad perspective and a deep understanding of diverse business challenges. He is committed to providing personalized service, proactive advice, and building long-term partnerships with clients, ensuring their financial success.",
                  img: Bipin,
                  der: "(Bcom)",
                },
              ].map((teamMember) => (
                <div
                  key={teamMember.name}
                  className="bg-[#005A8C] text-white rounded-3xl p-10 shadow-md"
                >
                  {/* Profile Image */}
                  <img
                    src={teamMember.img}
                    alt={teamMember.name}
                    title={teamMember.name}
                    className="w-[100px] h-[100px] rounded-full mx-auto mb-4 object-cover "
                  />
                  <h4 className="text-center text-2xl font-semibold mb-2">
                    {teamMember.name}
                  </h4>
                  <h4 className="text-center text-lg font-semibold mb-2">
                    {teamMember.der}
                  </h4>
                  <br></br>
                  <p>{teamMember.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Customer Testimonial Section */}
        <section className="py-12 bg-white">
          <div className="max-w-7xl mx-auto text-center px-4 sm:px-6 lg:px-8">
            <h3 className="text-3xl font-bold mb-8 text-blue-800">
              Customer <span className="text-orange-500">Testimonial</span>
            </h3>
            <div className="bg-gray-100 p-6 rounded-lg shadow-md max-w-4xl mx-auto flex flex-col sm:flex-row items-center sm:space-x-6 space-y-6 sm:space-y-0">
              {/* Customer Image */}
              <img
                src={customer} // Replace with your actual customer image path
                alt="Customer"
                className="w-24 h-24 rounded-full object-cover"
              />
              {/* Testimonial Content */}
              <div className="text-left">
                <p className="text-gray-700 mb-4">
                  "Top notch. Very good customer service and quick at answering
                  my queries. I really enjoy working with them. I have had
                  dealings with members of Smooth Accounting since July 2022. I
                  have found the staff all so easy to talk to and incredibly
                  knowledgeable. I would not hesitate to recommend their
                  services. You can tell they really care, they go above and
                  beyond to look after their customers. They are quick to
                  respond and no question is too small. I honestly can’t say
                  anything negative about my experiences working with them.
                  Brilliant customer service!"
                </p>
                <p className="font-bold text-gray-800">
                  Owner of reputed trading firm
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Get in Touch Section */}
        <section className="py-12 bg-white">
          <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between bg-gray-100 p-6 rounded-lg shadow-md">
            {/* Left Content */}
            <div>
              <h3 className="text-xl font-bold text-gray-800 mb-2">
                Get in touch
              </h3>
              <p className="text-gray-600">
                If you have any queries or questions, please reach out to us by
                clicking on the contact button and filling out the form.
              </p>
            </div>

            {/* Buttons */}
            <div className="flex space-x-4 mt-6 md:mt-0">
              <button
                onClick={handleAppointmentClick}
                className="bg-orange-500 text-white px-6 py-2 rounded hover:bg-orange-600 transition duration-200"
              >
                Make Appointment
              </button>
              <button
                onClick={handleClick}
                className="bg-[#005A8C] text-white px-6 py-2 rounded hover:bg-blue-900 transition duration-200"
              >
                Contact Us
              </button>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};
export default Home;
